import React from "react";
import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import styles from "./MostWatchedSeries.module.css"
import { IMAGE } from "../../../../api";

import { Link } from "react-router-dom";


const MostWatchedSeries = ({tv_show_dashboard}) => {
  // console.log(tv_show_dashboard,"parthgohel")
 
  const NewCustomersData = tv_show_dashboard||[];
  return (
    <>
      <Card
        sx={{
          // boxShadow: "var(--gradientColorLightest2) 0px 6px 12px -2px, var(--gradientColorLightest1) 0px 3px 7px -3px",
          boxShadow: "#f58e0a 0px 3px 6px -1px, #f95506 0px 2px 4px -1px",
          borderRadius: "10px",
          p: "25px 20px",
          mb: "15px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #EEF0F7",
            paddingBottom: "10px",
            mb: "20px",
          }}
          className="for-dark-bottom-border"
        >
          <Typography
            as="h3"
            sx={{
              fontSize: 18,
              fontWeight: 500,
            }}
          >
            Highest Rented Series
          </Typography>

          
      
        </Box>

        <Box>
          {NewCustomersData.slice(0, 5).map((movie) => (
            <div className={styles.newCustomerList} key={movie?.id}>
              <div className={styles.leftContent}>
                <img src={IMAGE+movie?.series_thumbnail} alt="user" />
                <div>
                  <Link to="/Series/Series/SeriesDetails" state={{ id: movie?.id }}>
                  <p style={{ fontWeight: "600" }} >{movie?.series_name.length > 25 ?movie?.series_name.substring(0,25)+"..." :movie?.series_name}</p>
                  </Link>
                  {/* <p>{movie?.movie_category} (<span style={{color:"var(--gradientColor2)"}}>{movie?.movie_subcategory}</span>)</p> */}
                 
                </div>
              </div>
              <div className={styles.rightContent}>
                <div className={styles.published_by}>
                {/* <p>{movie?.watch_hours}</p> */}
                <p>Rental Count:  {movie?.rental_count}</p>
                </div>
                {/* <div className={styles.downloads}>
                  {movie?.seriesViews||0}
                </div> */}
              </div>
            </div>
          ))}
        </Box>
      </Card>
    </>
  );
};

export default MostWatchedSeries;
